import { AnyAction, combineReducers, createStore, Store } from 'redux'

import formReducer from './features/form.redux'
import dataModelsReducer from './features/data-models.redux'
import dealersReducer from './features/dealers.redux'
import sessionReducer from './features/session.redux'
import dataStorageReducer from './features/data-storage.redux'
import keycloakReducer from './features/keycloak.redux'
import { RootState } from './types'

const rootReducer = combineReducers({
  form: formReducer,
  dataModel: dataModelsReducer,
  dealers: dealersReducer,
  session: sessionReducer,
  dataStorage: dataStorageReducer,
  keycloak: keycloakReducer,
})

/* eslint-disable no-underscore-dangle */
const store: Store<RootState, AnyAction> = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
/* eslint-enable */

export type AppDispatch = typeof store.dispatch
export { store }
